import { c as _c } from "react/compiler-runtime";
import { ZIN_DISPLAY_KEY_STORY_VILLA_CITY_PAGE, ZIN_KEY } from "@website/accommodation-ui/constant";
import { HotelCitiesMainContent } from "@website/accommodation-ui/hotel-cities-main-content";
import { HotelFilter } from "@website/accommodation-ui/hotel-filter";
import { HotelListHeader } from "@website/accommodation-ui/hotel-list-header";
import { HotelCityTitle } from "@website/accommodation-ui/hotel-list-header/hotel-city-title";
import { HotelSortView } from "@website/accommodation-ui/hotel-list-header/hotel-sort-view";
import { HotelPagination } from "@website/accommodation-ui/hotel-pagination";
import { HotelShortVideos } from "@website/accommodation-ui/hotel-short-videos";
import { HotelUpdateSearchModal } from "@website/accommodation-ui/hotel-update-search-modal";
import { ListingContainer } from "@website/accommodation-ui/listing-container";
import { VillaMeta } from "@website/accommodation-ui/villa-meta";
import { VillaSearch } from "@website/accommodation-ui/villa-search";
import { useIsVisible } from "@website/hooks/is-visible";
import { MaterialIcon } from "@website/icons/material";
import { getTracking } from "@website/store/tracking";
import { Breadcrumb } from "@website/ui/breadcrumb";
import { Switch } from "@website/ui/switch";
import { isChannel } from "@website/utils/channel/helpers";
import { deepOmit } from "@website/utils/deep-omit";
import { isFilled } from "@website/utils/is-filled";
import { BannerSlide } from "@website/widget/banner-slide";
import { Footer } from "@website/widget/footer";
import { Header } from "@website/widget/header";
import { AnimatedButton } from "@website/widget/search-map/animatedButton";
import { SeoComponents } from "@website/widget/seo-components";
import { Telesales } from "@website/widget/telesales";
import isEmpty from "lodash-es/isEmpty";
import omit from "lodash-es/omit";
import { NextPage } from "next";
import { useRouter } from "next/router";
import { useState, useSyncExternalStore } from "react";
import Custom404 from "../../[...gone].page";
import { useCityPage } from "./index.hook";
import { CityPagePropertiesType } from "./index.types";
const stripCollapseObserverOptions = {
  rootMargin: "120px 0px 0px 0px",
  threshold: 0
};
const stripExpandObserverOptions = {
  rootMargin: "24px 0px 0px 0px",
  threshold: 0
};
type StableStripTriggerState = {
  collapseTriggerInView: boolean;
  expandTriggerInView: boolean;
  stripTriggerInView: boolean;
};
const subscribeToClientRender = () => () => {};
const getClientSnapshot = () => true;
const getServerSnapshot = () => false;
const getNextStripTriggerInView = (current: boolean, collapseTriggerInView: boolean, expandTriggerInView: boolean) => {
  if (current && !collapseTriggerInView) return false;
  if (!current && expandTriggerInView) return true;
  return current;
};
const useStableStripTrigger = (collapseTriggerInView, expandTriggerInView) => {
  const $ = _c(7);
  let t0;
  if ($[0] !== collapseTriggerInView || $[1] !== expandTriggerInView) {
    t0 = {
      collapseTriggerInView,
      expandTriggerInView,
      stripTriggerInView: true
    };
    $[0] = collapseTriggerInView;
    $[1] = expandTriggerInView;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const [state, setState] = useState(t0);
  if (state.collapseTriggerInView !== collapseTriggerInView || state.expandTriggerInView !== expandTriggerInView) {
    let t1;
    if ($[3] !== collapseTriggerInView || $[4] !== expandTriggerInView || $[5] !== state.stripTriggerInView) {
      t1 = getNextStripTriggerInView(state.stripTriggerInView, collapseTriggerInView, expandTriggerInView);
      $[3] = collapseTriggerInView;
      $[4] = expandTriggerInView;
      $[5] = state.stripTriggerInView;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    const stripTriggerInView = t1;
    setState({
      collapseTriggerInView,
      expandTriggerInView,
      stripTriggerInView
    });
    return stripTriggerInView;
  }
  return state.stripTriggerInView;
};
const CityPageContent: NextPage<CityPagePropertiesType> = properties => {
  const $ = _c(128);
  const router = useRouter();
  const {
    hasMap,
    isNewPlP,
    onMapClick,
    modalProps,
    headerProps,
    searchProperties,
    bannersProperties,
    telesaleProperties,
    hotelPaginationProps,
    hotelListHeaderProps,
    citiesFilterProperties,
    hotelBreadcrumbsProperties,
    hotelCitiesMainContentProps,
    listingContainerProps
  } = useCityPage(properties);
  const zinStoryTag = `${router?.query?.locationType}/${router?.query?.cityTitle}`;
  const {
    reference: stripCollapseTriggerReference,
    inView: stripCollapseTriggerInView
  } = useIsVisible(stripCollapseObserverOptions, true);
  const {
    reference: stripExpandTriggerReference,
    inView: stripExpandTriggerInView
  } = useIsVisible(stripExpandObserverOptions, true);
  const stripTriggerInView = useStableStripTrigger(stripCollapseTriggerInView, stripExpandTriggerInView);
  const t0 = properties?.seoData?.title;
  const t1 = properties?.seoData?.description;
  const t2 = properties.locationData?.type;
  const t3 = properties.locationData?.title;
  let t4;
  if ($[0] !== t0 || $[1] !== t1 || $[2] !== t2 || $[3] !== t3) {
    t4 = <VillaMeta title={t0} description={t1} locationType={t2} locationTitle={t3} />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== stripCollapseTriggerReference) {
    t5 = <div className="absolute inset-x-0 top-0 h-px" ref={stripCollapseTriggerReference} />;
    $[5] = stripCollapseTriggerReference;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== stripExpandTriggerReference) {
    t6 = <div className="absolute inset-x-0 top-0 h-px" ref={stripExpandTriggerReference} />;
    $[7] = stripExpandTriggerReference;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div aria-hidden={true} className="pointer-events-none relative h-0 w-full">{t5}{t6}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== modalProps) {
    t8 = <HotelUpdateSearchModal {...modalProps} />;
    $[12] = modalProps;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== headerProps) {
    t9 = <Header {...headerProps} />;
    $[14] = headerProps;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="bg-outline-thin h-px w-full" />;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const t11 = `sticky top-0 bg-white ${searchProperties.isSearchPanelOpen ? "z-20" : "z-10 md:z-20"}`;
  let t12;
  if ($[17] !== isNewPlP || $[18] !== searchProperties) {
    t12 = <VillaSearch {...searchProperties} disableSticky={true} isNewPlP={isNewPlP} />;
    $[17] = isNewPlP;
    $[18] = searchProperties;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== hasMap || $[21] !== hotelListHeaderProps || $[22] !== isNewPlP || $[23] !== onMapClick || $[24] !== stripTriggerInView) {
    t13 = isNewPlP && <HotelListHeader {...hotelListHeaderProps} isSticky={isNewPlP} isStickyPositioned={false} stripTriggerInView={stripTriggerInView} hasMap={hasMap} onMapClick={onMapClick} />;
    $[20] = hasMap;
    $[21] = hotelListHeaderProps;
    $[22] = isNewPlP;
    $[23] = onMapClick;
    $[24] = stripTriggerInView;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t11 || $[27] !== t12 || $[28] !== t13) {
    t14 = <div className={t11}>{t12}{t13}</div>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== hasMap || $[31] !== isNewPlP || $[32] !== onMapClick) {
    t15 = isNewPlP && hasMap && onMapClick && <div className="lg:hidden"><AnimatedButton isNewPlP={true} className="bottom-6" icon={<MaterialIcon className="text-headline-6" name="map" variant="outlined" />} onClick={onMapClick} expandedText={"\u0646\u0645\u0627\u06CC\u0634 \u0631\u0648\u06CC \u0646\u0642\u0634\u0647"} text={"\u0646\u0642\u0634\u0647"} /></div>;
    $[30] = hasMap;
    $[31] = isNewPlP;
    $[32] = onMapClick;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  const t16 = `flex flex-col gap-5 ${isNewPlP ? "px-4" : "px-6"} lg:px-6 lg:py-5 xl:mx-auto xl:max-w-[1200px] xl:px-0`;
  let t17;
  if ($[34] !== hotelBreadcrumbsProperties || $[35] !== isNewPlP) {
    t17 = !isNewPlP && <div className="hidden lg:flex"><Breadcrumb {...hotelBreadcrumbsProperties} /></div>;
    $[34] = hotelBreadcrumbsProperties;
    $[35] = isNewPlP;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  const t18 = `${isNewPlP ? "lg:flex" : ""} hidden flex-row items-center justify-between`;
  let t19;
  if ($[37] !== hotelListHeaderProps.city || $[38] !== hotelListHeaderProps.hasCityPrefix || $[39] !== hotelListHeaderProps.loading || $[40] !== hotelListHeaderProps.totalItem || $[41] !== isNewPlP) {
    t19 = isNewPlP && <div className="lg:mt-0"><HotelCityTitle isNewPlP={isNewPlP} city={hotelListHeaderProps?.city} hasCityPrefix={hotelListHeaderProps?.hasCityPrefix} loading={hotelListHeaderProps?.loading} totalItem={hotelListHeaderProps?.totalItem} /></div>;
    $[37] = hotelListHeaderProps.city;
    $[38] = hotelListHeaderProps.hasCityPrefix;
    $[39] = hotelListHeaderProps.loading;
    $[40] = hotelListHeaderProps.totalItem;
    $[41] = isNewPlP;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== hotelBreadcrumbsProperties) {
    t20 = <div className="hidden lg:flex"><Breadcrumb {...hotelBreadcrumbsProperties} className="hidden lg:flex" /></div>;
    $[43] = hotelBreadcrumbsProperties;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t19 || $[46] !== t20) {
    t21 = <div className="flex flex-col gap-1">{t19}{t20}</div>;
    $[45] = t19;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== hotelListHeaderProps.sortProperties || $[49] !== isNewPlP) {
    t22 = <HotelSortView {...hotelListHeaderProps.sortProperties} isNewPlP={isNewPlP} />;
    $[48] = hotelListHeaderProps.sortProperties;
    $[49] = isNewPlP;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== hasMap || $[52] !== isNewPlP || $[53] !== onMapClick) {
    t23 = hasMap && onMapClick && <AnimatedButton isNewPlP={isNewPlP} className={isNewPlP ? "bottom-6" : "bottom-[20px]"} icon={<MaterialIcon className="text-headline-6" name="map" variant="outlined" />} onClick={onMapClick} expandedText={"\u0646\u0645\u0627\u06CC\u0634 \u0631\u0648\u06CC \u0646\u0642\u0634\u0647"} text={"\u0646\u0642\u0634\u0647"} />;
    $[51] = hasMap;
    $[52] = isNewPlP;
    $[53] = onMapClick;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] !== t22 || $[56] !== t23) {
    t24 = <div className="flex flex-row items-center gap-4">{t22}{t23}</div>;
    $[55] = t22;
    $[56] = t23;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  let t25;
  if ($[58] !== t18 || $[59] !== t21 || $[60] !== t24) {
    t25 = <div className={t18}>{t21}{t24}</div>;
    $[58] = t18;
    $[59] = t21;
    $[60] = t24;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  const t26 = `${isNewPlP ? "md:block" : ""} p-0`;
  let t27;
  if ($[62] !== bannersProperties?.bannerSlideList || $[63] !== isNewPlP) {
    t27 = !isNewPlP && bannersProperties?.bannerSlideList?.length > 0 && <div className="hidden w-[312px] pb-4 xl:block"><BannerSlide className="p-0" list={bannersProperties?.bannerSlideList} /></div>;
    $[62] = bannersProperties?.bannerSlideList;
    $[63] = isNewPlP;
    $[64] = t27;
  } else {
    t27 = $[64];
  }
  let t28;
  if ($[65] !== citiesFilterProperties || $[66] !== isNewPlP) {
    t28 = <HotelFilter {...citiesFilterProperties} isNewPlP={isNewPlP} />;
    $[65] = citiesFilterProperties;
    $[66] = isNewPlP;
    $[67] = t28;
  } else {
    t28 = $[67];
  }
  let t29;
  if ($[68] !== t26 || $[69] !== t27 || $[70] !== t28) {
    t29 = <div className={t26}>{t27}{t28}</div>;
    $[68] = t26;
    $[69] = t27;
    $[70] = t28;
    $[71] = t29;
  } else {
    t29 = $[71];
  }
  const t30 = `flex min-w-0 shrink grow flex-col ${isNewPlP ? "gap-3" : "gap-5"} lg:gap-4`;
  let t31;
  if ($[72] !== hotelListHeaderProps || $[73] !== isNewPlP) {
    t31 = !isNewPlP && <HotelListHeader {...hotelListHeaderProps} />;
    $[72] = hotelListHeaderProps;
    $[73] = isNewPlP;
    $[74] = t31;
  } else {
    t31 = $[74];
  }
  const t32 = `${isNewPlP ? "-mt-0" : "-mt-5"} bg-on-color-high-emphasis border-outline-thin -mx-4 border-b px-4 lg:m-0 lg:hidden`;
  let t33;
  if ($[75] !== t32 || $[76] !== zinStoryTag) {
    t33 = <HotelShortVideos className={t32} displayType="STORY" displayId={ZIN_DISPLAY_KEY_STORY_VILLA_CITY_PAGE} zinKey={ZIN_KEY} zinTags={zinStoryTag} />;
    $[75] = t32;
    $[76] = zinStoryTag;
    $[77] = t33;
  } else {
    t33 = $[77];
  }
  let t34;
  if ($[78] !== hotelListHeaderProps.city || $[79] !== hotelListHeaderProps.hasCityNearby || $[80] !== hotelListHeaderProps.sortProperties || $[81] !== hotelPaginationProps || $[82] !== isNewPlP || $[83] !== router) {
    t34 = isNewPlP && <div className="lg:mt-0 lg:hidden"><div className="flex w-full flex-row items-center justify-between gap-4"><div className="min-w-0 flex-1"><HotelCityTitle className="!pt-0" city={hotelListHeaderProps?.city} hasCityPrefix={router.query.locationType !== "category"} loading={hotelPaginationProps.loading} totalItem={hotelPaginationProps.totalCount} /></div><div className="flex shrink-0 flex-row items-center gap-2">{hotelListHeaderProps?.hasCityNearby && getTracking()?.experiment?.experiment_nearby_cities_toggle === "true" && <Switch name="nearby" key={`nearby=${router.query?.nearby}`} label={"\u0648\u06CC\u0644\u0627\u0647\u0627\u06CC \u0627\u0637\u0631\u0627\u0641"} checked={Boolean(router.query?.nearby)} onChange={() => router.replace({
            query: deepOmit({
              ...omit(router.query, ["geo_property_summary"]),
              nearby: !router.query?.nearby || undefined
            }, isFilled)
          }, undefined, {
            shallow: true,
            scroll: false
          })} color="secondary" className="!text-body-2 flex flex-row-reverse !items-center !justify-end !whitespace-nowrap !pb-0 lg:!hidden" />}<HotelSortView {...hotelListHeaderProps.sortProperties} buttonProps={{
            "aria-label": "\u0645\u0631\u062A\u0628\u200C\u0633\u0627\u0632\u06CC",
            children: undefined,
            className: "!px-0 [&>span:first-child]:!h-9 [&>span:first-child]:!w-9",
            color: router.query.order_by ? "secondary" : "neutral",
            equalDimension: true,
            size: "small",
            StartIcon: <MaterialIcon className="text-[24px] leading-9" name="sort" />,
            variant: "text"
          }} isNewPlP={isNewPlP} /></div></div></div>;
    $[78] = hotelListHeaderProps.city;
    $[79] = hotelListHeaderProps.hasCityNearby;
    $[80] = hotelListHeaderProps.sortProperties;
    $[81] = hotelPaginationProps;
    $[82] = isNewPlP;
    $[83] = router;
    $[84] = t34;
  } else {
    t34 = $[84];
  }
  let t35;
  if ($[85] !== hotelCitiesMainContentProps || $[86] !== isNewPlP || $[87] !== listingContainerProps) {
    t35 = isNewPlP ? <ListingContainer {...listingContainerProps} /> : <HotelCitiesMainContent {...hotelCitiesMainContentProps} />;
    $[85] = hotelCitiesMainContentProps;
    $[86] = isNewPlP;
    $[87] = listingContainerProps;
    $[88] = t35;
  } else {
    t35 = $[88];
  }
  let t36;
  if ($[89] !== hotelPaginationProps || $[90] !== t35) {
    t36 = <div className="relative"><HotelPagination {...hotelPaginationProps}>{t35}</HotelPagination></div>;
    $[89] = hotelPaginationProps;
    $[90] = t35;
    $[91] = t36;
  } else {
    t36 = $[91];
  }
  let t37;
  if ($[92] !== hasMap || $[93] !== isNewPlP || $[94] !== onMapClick) {
    t37 = hasMap && !isNewPlP && <AnimatedButton className="bottom-[20px] self-center md:bottom-6 md:!self-auto xl:!hidden" icon={<MaterialIcon name="map" variant="outlined" />} isNewPlP={isNewPlP} onClick={onMapClick} text={"\u0646\u0645\u0627\u06CC\u0634 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647\u200C\u0647\u0627 \u0631\u0648\u06CC \u0646\u0642\u0634\u0647"} />;
    $[92] = hasMap;
    $[93] = isNewPlP;
    $[94] = onMapClick;
    $[95] = t37;
  } else {
    t37 = $[95];
  }
  let t38;
  if ($[96] !== t30 || $[97] !== t31 || $[98] !== t33 || $[99] !== t34 || $[100] !== t36 || $[101] !== t37) {
    t38 = <main className={t30}>{t31}{t33}{t34}{t36}{t37}</main>;
    $[96] = t30;
    $[97] = t31;
    $[98] = t33;
    $[99] = t34;
    $[100] = t36;
    $[101] = t37;
    $[102] = t38;
  } else {
    t38 = $[102];
  }
  let t39;
  if ($[103] !== t29 || $[104] !== t38) {
    t39 = <div className="relative flex">{t29}{t38}</div>;
    $[103] = t29;
    $[104] = t38;
    $[105] = t39;
  } else {
    t39 = $[105];
  }
  let t40;
  if ($[106] !== properties.seoData) {
    t40 = <div className="w-full px-6 py-2 xl:mx-auto xl:max-w-[1200px]"><SeoComponents seoData={properties.seoData} linksTitle={"\u0627\u062C\u0627\u0631\u0647 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647 \u062F\u0631 \u0634\u0647\u0631\u0647\u0627\u06CC \u067E\u0631\u0637\u0631\u0641\u062F\u0627\u0631"} /></div>;
    $[106] = properties.seoData;
    $[107] = t40;
  } else {
    t40 = $[107];
  }
  let t41;
  if ($[108] !== telesaleProperties) {
    t41 = !isChannel(["b2b", "telesale"]) && <Telesales {...telesaleProperties} />;
    $[108] = telesaleProperties;
    $[109] = t41;
  } else {
    t41 = $[109];
  }
  let t42;
  if ($[110] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <Footer />;
    $[110] = t42;
  } else {
    t42 = $[110];
  }
  let t43;
  if ($[111] !== t16 || $[112] !== t17 || $[113] !== t25 || $[114] !== t39 || $[115] !== t40 || $[116] !== t41) {
    t43 = <div className={t16}>{t17}{t25}{t39}{t40}{t41}{t42}</div>;
    $[111] = t16;
    $[112] = t17;
    $[113] = t25;
    $[114] = t39;
    $[115] = t40;
    $[116] = t41;
    $[117] = t43;
  } else {
    t43 = $[117];
  }
  let t44;
  if ($[118] !== t14 || $[119] !== t15 || $[120] !== t43 || $[121] !== t7 || $[122] !== t8 || $[123] !== t9) {
    t44 = <div className="bg-dim-background">{t7}{t8}{t9}{t10}{t14}{t15}{t43}</div>;
    $[118] = t14;
    $[119] = t15;
    $[120] = t43;
    $[121] = t7;
    $[122] = t8;
    $[123] = t9;
    $[124] = t44;
  } else {
    t44 = $[124];
  }
  let t45;
  if ($[125] !== t4 || $[126] !== t44) {
    t45 = <>{t4}{t44}</>;
    $[125] = t4;
    $[126] = t44;
    $[127] = t45;
  } else {
    t45 = $[127];
  }
  return t45;
};
const Index: NextPage<CityPagePropertiesType> = properties => {
  const $ = _c(3);
  const router = useRouter();
  const hasMounted = useSyncExternalStore(subscribeToClientRender, getClientSnapshot, getServerSnapshot);
  const hasQueryParameters = !isEmpty(omit(router.query, ["locationType", "cityTitle"]));
  if (!properties.locationData) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Custom404 />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (hasQueryParameters && !hasMounted) {
    return null;
  }
  let t0;
  if ($[1] !== properties) {
    t0 = <CityPageContent {...properties} />;
    $[1] = properties;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default Index;
export { getServerSideProps } from "./index.server";